<template>
    <v-sheet :style="'background-color:'+colorBG+'!important'" color="bgCard" class="cardTopology" >       
        <v-col class="ma-0 pa-0" cols="12" align-self="center">
            <div class='text-center'> 
                <v-chip                
                class="ma-2"
                :class="'normalChip'"
                :color="COLOR.greyfake"           
                >
                  <span class="textDashboard" >{{ status.toUpperCase() }}</span>
                </v-chip>                

                <div class="container-img">
                    <v-img class="img-topo" v-if="images !== null" :src="images"></v-img>
                </div>
                <div class='title-card'>
                    <span class="textDashboard"> {{ title }} </span>                
                    <div class='subtitle-card'>
                        {{ description }}
                    </div>
                </div>
                <div class='ip-card'>
                    {{ ip }}
                </div>
            </div>
        </v-col>
    </v-sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { COLOR } from '@/constants/colors';
import CONSTANTIMGS from '@/constants/images';

/********************************
 ********** INTERFACES **********
 *******************************/
import { IMGS } from '@/interfaces/SmartLink/Imgs';

const props = defineProps({
    status      :{ type:String, required:true, },
    title       :{ type:String, required:true, },
    ip          :{ type:String, required:true, },
    description :{ type:String, required:true, },
})

const colorBG             = computed(() => COLOR.bgpredict);

const CONST_IMG:IMGS        = {
    "PMP-SM"        : CONSTANTIMGS.IMAGES.onlypmp,
    "PMP"           : CONSTANTIMGS.IMAGES.onlypmp,
    "PMP-AP"        : CONSTANTIMGS.IMAGES.onlypmp,
};

const images                = computed(() => CONST_IMG[props.description])


</script>

<style scoped>

.cardTopology{    
  margin: 5px;
  border: 3px solid rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 5px;
  min-height: 150px;
  background-color: white;
  transition: 1s;
  transform: translateY(0px);
}

.cardTopology:hover{
    cursor: pointer;
    transform: translateY(-7px);
}

.container-img{
  height: 115px;
  margin: 0 auto;
 }

 .container-img .img-topo{
    filter: drop-shadow(0px 23px 12px rgba(63,63,63,0.5));
 }

.title-card{
  margin-top: 7px;
  height: 60px;
  overflow: hidden;
  line-height: 15px;
}

.title-card span{
  font-size: 14px;
  font-weight: 500;
}

.title-card .subtitle-card{
  font-size: 10px;
  font-family: 'Poppins', sans-serif;
  color: rgb(var(--v-theme-subtitle));
}

.ip-card{
  font-size: 12px;   
  font-family: 'Poppins', sans-serif;
  font-weight: 400;

}

</style>